export const messages = {
  "geo.redirect.menu": "Redirije",
  "geo.redirect.operation": "Operasyon",
  "geo.redirect.source": "Sant pou dezaktive",
  "geo.redirect.sourceHint": "Elekt\u00e8 li yo pral transfere",
  "geo.redirect.target": "Sant destinasyon",
  "geo.redirect.targetHint": "Sant ki rete aktif la",
  "geo.redirect.selected": "Chwazi",
  "geo.redirect.clear": "Efase seleksyon an",
  "geo.redirect.search": "Ch\u00e8che sant, k\u00f2d oswa lokalite",
  "geo.redirect.department": "Depatman",
  "geo.redirect.allDepartments": "Tout depatman yo",
  "geo.redirect.centerCount": "{count} sant",
  "geo.redirect.noResults": "Pa gen sant ki koresponn ak rech\u00e8ch la.",
  "geo.redirect.noLocation": "Lokalite pa presize",
  "geo.redirect.previous": "Paj anvan",
  "geo.redirect.next": "Paj apre",
  "geo.redirect.swap": "Chanje sant sous ak destinasyon",
  "geo.redirect.preview": "Ap\u00e8si sou redireksyon an",
  "geo.redirect.mergeEffect": "Sant destinasyon an rete aktif; sant sous la dezaktive.",
  "geo.redirect.closeEffect": "Sant sous la dezaktive epi elekt\u00e8 yo ale nan sant destinasyon an.",
  "geo.redirect.sourcePlaceholder": "Chwazi sant sous la",
  "geo.redirect.targetPlaceholder": "Chwazi sant destinasyon an",
  "geo.redirect.nextSteps": "Elekt\u00e8 ki deja la: transf\u00e8 chak \u00e8dtan. Nouvo apwobasyon: redireksyon otomatik. Lis ki pibliye yo pa chanje.",
  "geo.redirect.confirm": "Konfime redireksyon an",
  "geo.redirect.saving": "Ap anrejistre...",
  "geo.redirect.success": "Redireksyon an anrejistre",
  "geo.redirect.successDetail": "{voters} elekt\u00e8 pou transfere; {applications} demann ki lye ak ansyen sant lan.",
  "geo.redirect.newOperation": "Nouvo redireksyon",
  "geo.redirect.invalidPrefill": "Sant sa a pa ka s\u00e8vi k\u00f2m sous redireksyon.",
  "geo.redirect.reason.SAME_CENTER": "Yon sant pa ka redirije sou t\u00e8t li",
  "geo.redirect.reason.ALREADY_REDIRECTED": "Sant sa a deja redirije",
  "geo.redirect.reason.EXISTING_DESTINATION": "Sant sa a deja resevwa elekt\u00e8 l\u00f2t sant",
  "geo.redirect.reason.INVALID_STATUS": "Estati sant lan pa valab",
  "geo.redirect.reason.NOT_ENABLED": "Sant destinasyon an pa aktif",
  "geo.redirect.reason.MISSING_SECTION": "Seksyon kominal la pa defini",
  "operator.request.approve": "Apwouve",
  "operator.request.reject": "Rejte",
  "operator.request.loading": "Ap chaje…",
  "operator.request.reference": "Demann",
  "operator.request.fallbackName": "Demann kont operatè",
  "operator.request.identityHint": "Idantite moun ki fè demann nan",
  "operator.request.lifecycle": "Enskripsyon",
  "operator.request.lifecycleHint": "Eta ak dat demann nan",
  "operator.request.territory": "Zòn yo mande",
  "operator.request.territoryHint": "Kalite operatè ak zòn yo asiyen an",
  "operator.request.assignmentWarning": "Zòn ki mande a manke oswa li pa koresponn. Ou kapab toujou apwouve yon demann ki gen erè.",
  "operator.request.decision": "Desizyon",
  "operator.request.decisionHint": "Desizyon backoffice la",
  "operator.request.decisionReason": "Rezon",
  "operator.request.createdUser": "Kont operatè ki kreye",
  "operator.request.reviewer": "Moun ki revize nan backoffice",
  "operator.request.publicKey": "Kle piblik pou siyati",
  "operator.request.publicKeyHint": "Kle piblik moun nan bay",
  "operator.request.publicKeyQr": "Kòd QR kle piblik la",
  "operator.request.status.ERROR": "Erè",
  "operator.request.status.READY": "Pare",
  "operator.request.status.PENDING": "Annatant",
  "operator.request.status.APPROVED": "Apwouve",
  "operator.request.status.REJECTED": "Rejte",
  "operator.type": "Kalite operatè",
  "operator.type.all": "Tout kalite",
  "operator.type.CENTER": "CENTER",
  "operator.type.BEC": "BEC",
  "operator.type.BED": "BED",
  "operator.type.UNSPECIFIED": "Pa presize",
  "operator.scope": "Zòn afektasyon",
  "operator.scope.CENTER": "Sant vòt",
  "operator.scope.BEC": "Komin",
  "operator.scope.BED": "Depatman",
  "operator.scope.unassigned": "Afektasyon manke oswa pa koeran",
  "operator.requests.title": "Demann kont operatè",
  "operator.requests.subtitle": "Egzamine demann SANT, BEC ak BED selon kalite operatè ak zòn afektasyon.",
  "operator.request.invalidAssignment": "Kalite operatè a oswa zòn afektasyon an pa valab. Yo pa ka apwouve demann lan jiskaske yo korije li.",
  "operator.request.notFound": "Nou pa jwenn demann kont operatè a",
  "operator.account.notFound": "Nou pa jwenn kont operatè a",
  "maintenance.menu": "Antretyen",
  "maintenance.title": "Antretyen demann yo",
  "maintenance.description": "Swiv demann ki bezwen entèvansyon epi fè operasyon antretyen.",
  "maintenance.applications": "Demann ki bezwen atansyon",
  "maintenance.applicationsHint": "Demann ki gen erè oubyen ki bezwen revizyon manyèl.",
  "maintenance.allExceptions": "Tout pwoblèm yo",
  "maintenance.manualCheck": "Revizyon manyèl",
  "maintenance.refresh": "Rafrechi",
  "maintenance.details": "Dyagnostik",
  "maintenance.oniAttempts": "Tantativ ONI : {count}",
  "maintenance.reprocess": "Retrete",
  "maintenance.reprocessSelected": "Retrete sa yo chwazi ({count})",
  "maintenance.reprocessAll": "Retrete tout demann nan revizyon manyèl",
  "maintenance.selectPage": "Chwazi tout demann nan revizyon manyèl sou paj sa a",
  "maintenance.selectApplication": "Chwazi demann",
  "maintenance.searchPlaceholder": "Chèche non, NINU oswa nimewo resi",
  "maintenance.confirmTitle": "Konfime nouvo tretman an",
  "maintenance.confirmAll": "Retrete tout {count} demann ki nan revizyon manyèl yo ?",
  "maintenance.confirmSelected": "Retrete {count} demann sa yo ?",
  "maintenance.confirmExplanation": "Demann ki kalifye yo ap retounen nan estati Soumèt pou tretman nòmal la rekòmanse. Done ak dat depo yo p ap chanje ; operasyon an ap antre nan jounal chak demann.",
  "maintenance.reprocessedCount": "{count} demann retounen nan tretman.",
  "maintenance.loadFailed": "Pa kapab chaje demann ki bezwen atansyon yo.",
  "maintenance.actionFailed": "Pa kapab rekòmanse tretman demann yo.",
  "voter.applicationJournal": "Jounal demann lan",
  "voter.applicationJournalSubtitle": "Aksyon antretyen ak koreksyon ki fèt sou demann sa a",
  "voter.noJournalEntries": "Pa gen okenn antre nan jounal la.",
  "voter.journal.performedBy": "Fèt pa",
  "voter.journal.reprocessed": "Retounen nan tretman",
  "voter.journal.oniPhotoUsedForApproval": "Foto ONI itilize pou apwouve demann lan : demann lan te soumèt anvan 31 oktòb 2026 san foto",
  "voter.journal.faceVerificationSkippedNoPhoto": "Verifikasyon vizaj sote : demann lan te soumèt anvan 31 oktòb 2026 san foto",
  "voter.journal.systemActor": "Sistèm",
  "voter.reviewerBackofficeUserId": "ID itilizatè biwo revizè a",
  "voter.journal.manualAdjudication": "Voye pou egzamen manyèl",
  "voter.journal.reason": "Rezon",
  "voter.journal.reason.MISSING_VOTING_CENTER": "Pa gen sant vòt ki asiyen",
  "voter.journal.reason.INCOMPLETE_BIOGRAPHICAL_DATA": "Enfòmasyon biyografik obligatwa yo manke",
  "voter.journal.mismatchField": "Chan ki diferan",
  "voter.journal.applicationValue": "Valè ki nan demann nan",
  "voter.journal.identifiedPersonValue": "Valè moun yo idantifye a",
  "voter.journal.reason.BIOGRAPHICAL_MISMATCH": "Done demann lan pa koresponn ak done moun nan",
  "voter.journal.reason.MISSING_APPLICATION_PHOTO": "Foto demann lan manke",
"app.menu.cep_records.label": "Dosye moun",
"app.menu.cep_records.description": "Dosye idantite CEP",

  "app.menu.voter_applications.label": "Demand enskripsyon elektè",
  "app.menu.voter_applications.description": "Demand pou enskripsyon elektoral",

  "app.menu.voters.label": "Dosye elektè",
  "app.menu.voters.description": "Dosye elektè ki anrejistre",

  "app.menu.user_account_requests.label": "Demand kont itilizatè",
  "app.menu.user_account_requests.description": "Demand aksè pou kont itilizatè",
"app.menu.field_operators.label": "Operatè teren",
"app.menu.field_operators.description": "Kont operatè teren ak demand aksè",
"app.menu.user_accounts.label": "Kont operatè",
"app.menu.user_accounts.description": "Kont operatè teren",

  "app.menu.electoral_geography.label": "Jewografi elektoral",
  "app.menu.electoral_geography.description": "Sant vòt ak jewografi elektoral",

  "app.menu.actions.list": "Lis",
  "app.menu.actions.new": "Nouvo",

  "table.search": "Chèche",
  "table.noData": "Pa gen dosye",
  "table.rowsPerPage": "Liy pa paj",
  "table.of": "sou",

    "common.latest": "Pi resan",

  "Picture": "Foto",
  "Identifier": "Idantifyan",
  "First name": "Non",
  "Last name": "Siyati",
  "Date of birth": "Dat nesans",
  "Sex": "Sèks",
  "Primary contact": "Kontak prensipal",
  "Primary address": "Adrès prensipal",
  "Photo": "Foto",
  "Actions": "Aksyon",
  "View": "Gade",
  "Users": "Itilizatè yo",
  "menu.backoffice": "Backoffice",

  "Photo available": "Foto disponib",
    "app.menu.reporting.label": "Rapò",
    "app.menu.reporting.description": "Estatistik enskripsyon ak analiz jewografik",
    "app.menu.reporting.overview": "Apèsi",
    "app.menu.reporting.advanced": "Analiz avanse",
    "Operator reports": "Operatè yo",

    "menu.voter.registration": "Enskripsyon",
"menu.voter.applications": "Demann",
"menu.voter.records": "Elektè",
"Diagnostics": "Dyagnostik",
"menu.api_users": "Itilizatè API",
"app.menu.reporting.votingCenterReports": "Sant vòt yo",

    "app.menu.actions.manage": "Jere",
    "common.account": "kont",
    "common.accountLower": "kont",
    "common.accountsLower": "kont",
    "common.actions": "Aksyon",
    "common.active": "Aktif",
    "common.add": "Ajoute",
    "common.address": "Adrès",
    "common.all": "Tout",
    "common.allSources": "Tout sous",
    "common.allStatuses": "Tout estati",
    "common.appVersion": "Vèsyon aplikasyon",
    "common.application": "Demann",
    "common.approved": "Apwouve",
    "common.archived": "Achive",
    "common.area": "Zòn",
    "common.cancel": "Anile",
    "common.captured": "Kaptire",
    "common.class": "Klas",
    "common.clearAll": "Efase tout",
    "common.closeFilters": "Fèmen filtè yo",
    "common.code": "Kòd",
    "common.copy": "Kopye",
    "common.day": "Jou",
    "common.default": "Pa defo",
    "common.deleted": "Efase",
    "common.description": "Deskripsyon",
    "common.details": "Detay",
    "common.device": "Aparèy",
    "common.deviceId": "ID aparèy",
    "common.disabled": "Dezaktive",
    "common.done": "Fini",
    "common.edit": "Modifye",
    "common.empty": "(vid)",
    "common.error": "Erè",
    "common.event": "Evènman",
    "common.filters": "Filtè",
    "common.first": "Premye",
    "common.format": "Fòma",
    "common.from": "Depi",
    "common.generated": "Jenere",
    "common.generating": "Jenerasyon...",
    "common.geography": "Jewografi",
    "common.id": "ID",
    "common.identifier": "Idantifyan",
    "common.interval": "Entèval",
    "common.last": "Dènye",
    "common.level": "Nivo",
    "common.loading": "Chajman...",
    "common.loading.short": "Chajman",
    "common.localFile": "Fichye lokal",
    "common.message": "Mesaj",
    "common.metric": "Endikatè",
    "common.month": "Mwa",
    "common.name": "Non",
    "common.next": "Apre",
    "common.no": "Non",
    "common.noAddress": "(pa gen adrès)",
    "common.noReceipt": "(pa gen resi)",
    "common.noResults": "Pa gen rezilta.",
    "common.notVerified": "Pa verifye",
    "common.nothingSelected": "Pa gen anyen chwazi.",
    "common.objectKey": "Kle objè",
    "common.other": "Lòt",
    "common.page": "paj",
    "common.parent": "Paran",
    "common.pending": "Ann atant",
    "common.person": "Moun",
    "common.photo": "Foto",
    "common.picture": "Foto",
    "common.prev": "Anvan",
    "common.primary": "Prensipal",
    "common.ready": "Pare",
    "common.rejected": "Rejte",
    "common.remove": "Retire",
    "common.report": "Rapò",
    "common.reset": "Reyajiste",
    "common.resetFilters": "Reyajiste filtè yo",
    "common.reviewed": "Revize",
    "common.save": "Anrejistre",
    "common.saving": "Anrejistreman...",
    "common.selectItemTree": "Chwazi yon eleman nan pyebwa a",
    "common.selectedItem": "Eleman chwazi",
    "common.shown": "afiche",
    "common.since": "depi",
    "common.source": "Sous",
    "common.splash": "ekran akèy",
    "common.status": "Estati",
    "common.submitted": "Soumèt",
    "common.summary": "Rezime",
    "common.tabletId": "ID tablèt",
    "common.tags": "Etikèt",
    "common.thread": "Fil ekzekisyon",
    "common.time": "Lè",
    "common.to": "Jiska",
    "common.total": "Total",
    "common.type": "Kalite",
    "common.unknown": "Enkoni",
    "common.unnamed": "San non",
    "common.updatingCounts": "Mizajou kantite yo...",
    "common.user": "Itilizatè",
    "common.verifiedAt": "Verifye nan",
    "common.version": "Vèsyon",
    "common.view": "Gade",
    "common.viewSection": "Gade seksyon",
    "common.week": "Semèn",
    "common.yes": "Wi",
    "common.votingCenterGid": "GID sant vòt",
    "diagnostics.back": "Retounen nan dyagnostik",
    "diagnostics.copyReport": "Kopye rapò",
    "diagnostics.details": "Detay dyagnostik",
    "diagnostics.idPrefix": "ID dyagnostik",
    "diagnostics.loading": "Chajman dyagnostik...",
    "diagnostics.missingIdUrl": "ID dyagnostik manke nan URL la.",
    "diagnostics.noId": "Pa gen ID dyagnostik",
    "diagnostics.notFound": "Dyagnostik pa jwenn.",
    "diagnostics.view": "Gade dyagnostik",
    "filter.androidDiagnostic": "Dyagnostik Android",
    "filter.applicationFilters": "Filtè demann enskripsyon",
    "filter.deceased": "Mouri",
    "filter.diagnostic": "Dyagnostik",
    "filter.diagnosticFilters": "Filtè dyagnostik",
    "filter.eventType": "Kalite evènman",
    "filter.exclude": "Eskli",
    "filter.exclusionHelp": "Kache pa defo. Enkli montre yo ansanm ak lòt yo. Sèlman izole yo.",
    "filter.exclusions": "Eksklizyon",
    "filter.fatalCrash": "Krach fatal",
    "filter.female": "Fi",
    "filter.gender": "Sèks",
    "filter.age": "Laj",
    "filter.minimumAge": "Laj minimòm",
    "filter.maximumAge": "Laj maksimòm",
    "filter.hasTabletId": "Gen ID tablèt",
    "filter.hide": "Kache",
    "filter.include": "Enkli",
    "filter.male": "Gason",
    "filter.missingTabletId": "ID tablèt manke",
    "filter.nfcInventory": "Envantè NFC",
    "filter.noSexValues": "Pa gen valè sèks.",
    "filter.noTagValues": "Pa gen valè etikèt.",
    "filter.only": "Sèlman",
    "filter.operatorFilters": "Filtè operatè",
    "filter.operatorRequestFilters": "Filtè demann operatè",
    "filter.personFilters": "Filtè moun",
    "filter.refineApplications": "Rafine demann enskripsyon yo",
    "filter.refineDiagnostics": "Rafine dyagnostik yo",
    "filter.refineOperatorRequests": "Rafine demann operatè yo",
    "filter.refineOperators": "Rafine operatè yo",
    "filter.refinePeople": "Rafine moun yo",
    "filter.refineVoters": "Rafine elektè yo",
    "filter.unresponsive": "Pa reponn",
    "filter.voterFilters": "Filtè elektè",
    "filter.votingCenterHide": "Kache",
    "filter.votingCenterInclude": "Mete ladan",
    "filter.votingCenterOnly": "Sèlman",
    "filter.disabledCenters": "Sant vòt dezaktive",
    "filter.refineVotingCenters": "Rafine sant vòt yo",
    "filter.availability": "Disponiblite",
    "filter.disabledCentersHelp": "Sant vòt dezaktive yo kache pa defo. Mete ladan montre yo ansanm ak sant aktif yo. Sèlman montre sèlman sant dezaktive yo.",
    "filter.votingCenterReportFilters": "Filtè rapò sant vòt yo",
    "geo.addArrondissement": "Ajoute awondisman",
    "geo.addCommune": "Ajoute komin",
    "geo.addConstituency": "Ajoute sikonskripsyon",
    "geo.addDepartment": "Ajoute depatman",
    "geo.addSection": "Ajoute seksyon",
    "geo.addVotingCenter": "Ajoute sant vòt",
    "geo.arrondissement": "Awondisman",
    "geo.capacity": "Kapasite",
    "geo.communalSection": "Seksyon kominal",
    "geo.constituency": "Sikonskripsyon",
    "geo.item": "Eleman",
    "geo.noVotingCentersSection": "Pa gen sant vòt nan seksyon sa a.",
    "geo.subtitle": "Jere jewografi elektoral administratif ak pa sikonskripsyon.",
    "geo.tag": "Etikèt",
    "geo.tags.capacity50": "Avètisman kapasite 50%",
    "geo.tags.capacity70": "Avètisman kapasite 70%",
    "geo.tags.full": "Plen",
    "geo.title": "Jewografi elektoral",
    "geo.votingCenterGidRequired": "GID sant vòt la obligatwa pou mizajou.",
    "geo.votingCentersSelectedSection": "Sant vòt nan seksyon chwazi a",
    "menu.diagnostics.description": "Rapò dyagnostik aparèy teren",
    "menu.diagnostics.label": "Dyagnostik",
    "menu.reporting.operators": "Rapò operatè",
    "menu.users.description": "Itilizatè ak wòl aksè",
    "menu.users.label": "Itilizatè yo",
    "menu.voter.registration.description": "Demann enskripsyon ak rejis elektoral",
    "person.applicationSubmitted": "DEMANN SOUMÈT",
    "person.applications": "Demann",
    "person.birthDate": "Dat nesans",
    "person.commune": "Komin",
    "person.contact": "kontak",
    "person.contacts": "Kontak",
    "person.department": "Depatman",
    "person.firstName": "Non",
    "person.gid": "GID",
    "person.identity": "Idantite",
    "person.lastName": "Siyati",
    "person.nationalId": "Nimewo idantifikasyon nasyonal",
    "person.nationalIdentifier": "Nimewo idantifikasyon nasyonal",
    "person.noApplications": "Pa gen demann.",
    "person.noContacts": "Pa gen kontak.",
    "person.noPhotos": "Pa gen foto.",
    "person.noResidences": "Pa gen rezidans.",
    "person.noVoters": "Pa gen elektè.",
    "person.notRegistered": "PA ENSKRI",
    "person.officeIdentifierNumber": "Nimewo idantifikasyon biwo",
    "person.personGid": "GID moun",
    "person.photoAlt": "Foto moun nan",
    "person.photos": "Foto",
    "person.pictureAlt": "Foto moun nan",
    "person.recordNumber": "Nimewo dosye",
    "person.registered": "ENSKRI",
    "person.registrationDate": "Dat enskripsyon",
    "person.registrationStatus": "Estati enskripsyon",
    "person.residence": "Rezidans",
    "person.residences": "Rezidans",
    "person.section": "Seksyon",
    "person.sex": "Sèks",
    "person.unnamed": "Moun san non",
    "person.validFrom": "Valab depi",
    "person.validTo": "Valab jiska",
    "person.viewPerson": "Gade moun",
    "person.voters": "Elektè",
    "reporting.accountsAttachedNinu": "Kont ki lye ak NINU sa a",
    "reporting.activeCenters": "Sant aktif",
    "reporting.activeDays": "Jou aktif",
    "reporting.activeOperators": "Operatè aktif",
    "reporting.activitySpan": "Peryòd aktivite",
    "reporting.advanced": "Avanse",
    "reporting.affectedVoters": "Elektè konsène",
    "reporting.age18_28": "18 rive 28",
    "reporting.age29_38": "29 rive 38",
    "reporting.age39_48": "39 rive 48",
    "reporting.age49_58": "49 rive 58",
    "reporting.age59_68": "59 rive 68",
    "reporting.age69plus": "69 an oswa plis",
    "reporting.ageDistribution": "Distribisyon laj",
    "reporting.allArrondissements": "Tout awondisman",
    "reporting.allCommunes": "Tout komin",
    "reporting.allConstituencies": "Tout sikonskripsyon",
    "reporting.allDepartments": "Tout depatman",
    "reporting.allSections": "Tout seksyon",
    "reporting.allVotingCenters": "Tout sant vòt",
    "reporting.applicationMix": "Melanj demann",
    "reporting.applicationQuality": "Kalite demann",
    "reporting.applicationsLower": "demann",
    "reporting.applicationsToRoll": "Soti nan demann rive nan lis aktyèl",
    "reporting.applyFilters": "Aplike filtè",
    "reporting.assigned": "afekte",
    "reporting.assignedElsewhere": "Asiyen lòt kote",
    "reporting.busiestDay": "Jou ki pi aktif",
    "reporting.cadenceHelp": "Chak pwen se yon enskripsyon nan lè li te soumèt la. Klike sou yon pwen pou ouvri dosye a.",
    "reporting.capacityUtilization": "Itilizasyon kapasite",
    "reporting.capacityUtilizationByDepartment": "Itilizasyon kapasite pa depatman",
    "reporting.capacityUtilizationByDepartmentSubtitle": "Aplikan kòm pousantaj kapasite enskripsyon ki konfigire a.",
    "reporting.captureChannel": "Kanal kaptire",
    "reporting.centerLocation": "Kote sant lan",
    "reporting.centerNotFound": "Sant vòt pa jwenn.",
    "reporting.centerRegistrationCapacity": "Enskripsyon ak kapasite pa sant vòt",
    "reporting.centersLower": "sant",
    "reporting.centersWithin75Km": "sant nan yon reyon 75 km",
    "reporting.clearHourFilter": "Efase filtè lè",
    "reporting.clickCellInspect": "Klike yon selil pou egzamine jou sa a",
    "reporting.configured": "konfigire",
    "reporting.configuredCenters": "Sant konfigire",
    "reporting.correctionActivity": "Aktivite koreksyon",
    "reporting.correctionActivityDepartments": "Aplikan ki gen demann koreksyon pa depatman.",
    "reporting.correctionDemographics": "Demografi aplikan",
    "reporting.correctionDemographicsSubtitle": "Distribisyon sèks ak laj aplikan ki gen demann koreksyon.",
    "reporting.correctionHighlights": "Pwen kle koreksyon",
    "reporting.correctionHighlightsSubtitle": "Endikatè aplikan ki gen demann koreksyon nan dimansyon chwazi a.",
    "reporting.correctionReporting": "Rapò sou koreksyon",
    "reporting.correctionRequests": "Demann koreksyon",
    "reporting.correctionTimelineSubtitle": "Aplikan ki gen demann koreksyon sou tan.",
    "reporting.corrections": "Koreksyon",
    "reporting.correctionsByCenter": "Demann koreksyon pa sant vòt",
    "reporting.correctionsByDepartment": "Demann koreksyon pa depatman",
    "reporting.correctionsCenterSubtitle": "Aplikan ki gen demann koreksyon pa sant vòt.",
    "reporting.correctionsLower": "koreksyon",
    "reporting.cumulativeFirstTimeApplicants": "nouvo aplikan kimilatif",
    "reporting.currentElectoralRoll": "Lis elektoral aktyèl",
    "reporting.currentPollingStations": "Biwo vòt aktyèl",
    "reporting.currentVoters": "Elektè aktyèl",
    "reporting.dailyForensicView": "Analiz detaye chak jou",
    "reporting.dailyInspector": "Analiz chak jou",
    "reporting.dailyRegistrationActivity": "Aktivite enskripsyon chak jou",
    "reporting.dateHourMatrix": "Matris aktivite dat × lè",
    "reporting.distinctApplicants": "Aplikan diferan",
    "reporting.distinctVoters": "Elektè diferan",
    "reporting.distributionDay": "Distribisyon pandan jounen an",
    "reporting.drillDown": "Detay",
    "reporting.duplicateRetransmission": "Doub + retransmisyon",
    "reporting.duplicatesLower": "doub",
    "reporting.exactSubmissionCadence": "Kadans egzak soumèt yo",
    "reporting.firstApplicantsCapacity": "Nouvo aplikan konpare ak kapasite",
    "reporting.firstLower": "premye",
    "reporting.firstRequest": "Premye demann",
    "reporting.generalFilters": "Filtè jeneral",
    "reporting.geoCorrections": "Distribisyon jewografik koreksyon",
    "reporting.geoDrilldownSubtitle": "Distribisyon ak analiz elektè enskri atravè jewografi elektoral.",
    "reporting.geoRegistrations": "Distribisyon jewografik elektè enskri",
    "reporting.geographicScope": "Dimansyon jewografik",
    "reporting.gis": "GIS",
    "reporting.gpsCapacityField": "Chan GPS kapasite",
    "reporting.high": "Wo",
    "reporting.history": "Istwa",
    "reporting.hourFilterHelp": "Aplikan pa lè pou dat sa a. Klike sou yon lè pou filtre aplikan ki anba yo.",
    "reporting.identityLinkage": "Lyen idantite",
    "reporting.kmAway": "km lwen",
    "reporting.lastActivity": "Dènye aktivite",
    "reporting.lastLower": "dènye",
    "reporting.lastApplication": "Dènye demann",
    "reporting.lastRegistration": "Dènye enskripsyon",
    "reporting.lastRequest": "Dènye demann",
    "reporting.lifetimeHistory": "Istwa konplè",
    "reporting.loadingCenter": "Chajman rapò sant vòt…",
    "reporting.loadingDay": "Chajman jou a…",
    "reporting.loadingEllipsis": "Chajman…",
    "reporting.loadingOperator": "Chajman rapò operatè…",
    "reporting.location": "Lokalizasyon",
    "reporting.locationFootprint": "Anprent lokalizasyon",
    "reporting.locationLower": "lokasyon",
    "reporting.low": "Ba",
    "reporting.manual": "Manyèl",
    "reporting.nearbyCapacity": "Kapasite ki toupre",
    "reporting.nearbyCapacityLegend": "Gwosè boul = kapasite sant · koulè = itilizasyon pa aplikan · dyaman = sant chwazi",
    "reporting.nextDay": "Jou apre",
    "reporting.ninuIdentities": "Idantite NINU",
    "reporting.noActivityVisualize": "Pa gen aktivite pou montre.",
    "reporting.noCenter": "Pa gen sant",
    "reporting.noData": "Pa gen done rapò",
    "reporting.noDataSelectedFilters": "Pa gen done pou filtè chwazi yo.",
    "reporting.noDaySelected": "Pa gen jou chwazi.",
    "reporting.noGpsCoordinatesForCenter": "Pa gen kowòdone GPS ki disponib pou sant sa a.",
    "reporting.noOperators": "Pa jwenn operatè",
    "reporting.noRegistrationActivity": "Pa gen aktivite enskripsyon.",
    "reporting.noRegistrationHistory": "Pa gen istwa enskripsyon.",
    "reporting.noRegistrationsDay": "Pa gen enskripsyon jou sa a.",
    "reporting.noRegistrationsSelection": "Pa gen enskripsyon pou seleksyon sa a.",
    "reporting.ofCapacity": "sou",
    "reporting.on": "nan",
    "reporting.openMap": "Ouvri kat la",
    "reporting.openRegistration": "Louvri enskripsyon",
    "reporting.operatorActivityReport": "Rapò aktivite operatè",
    "reporting.operatorComposition": "Konpozisyon operatè",
    "reporting.operatorNotFound": "Operatè pa jwenn.",
    "reporting.operatorPerformance": "Pèfòmans operatè",
    "reporting.operatorPerformanceSubtitle": "Aplikan diferan chak operatè trete, konsolide atravè kont selon NINU operatè a.",
    "reporting.operatorPlaceholder": "Non, NINU oswa non itilizatè",
    "reporting.operatorReport": "Gade rapò operatè",
    "reporting.operators": "Operatè",
    "reporting.operatorsActiveHere": "operatè aktif isit la",
    "reporting.operatorsLower": "operatè",
    "reporting.outcomeComposition": "Konpozisyon rezilta",
    "reporting.overCapacity": "Depase kapasite",
    "reporting.overview": "Apèsi",
    "reporting.peak": "Pik",
    "reporting.perActiveDay": "Pa jou aktif",
    "reporting.plannedPollingStations": "Biwo vòt planifye",
    "reporting.previousDay": "Jou anvan",
    "reporting.refresh": "Rafrechi",
    "reporting.registeredVoters": "Elektè enskri",
    "reporting.registeredVotersLower": "elektè enskri",
    "reporting.registrationActivity": "Aktivite enskripsyon",
    "reporting.registrationCadence": "Kadans enskripsyon",
    "reporting.registrationCatchment": "Zòn enskripsyon",
    "reporting.registrationCenterSubtitle": "Aplikan, kapasite konfigire ak itilizasyon pa sant vòt.",
    "reporting.registrationHighlights": "Pwen kle enskripsyon",
    "reporting.registrationHighlightsSubtitle": "Endikatè enskripsyon pou dimansyon chwazi a.",
    "reporting.registrationProcess": "Pwosesis enskripsyon",
    "reporting.registrationStatuses": "Estati enskripsyon",
    "reporting.registrationTimelineSubtitle": "Aplikan sou tan.",
    "reporting.registrationType": "Kalite enskripsyon",
    "reporting.registrations": "Enskripsyon",
    "reporting.registrationsByCenter": "Enskripsyon pa sant vòt",
    "reporting.registrationsByDay": "Enskripsyon pa jou",
    "reporting.registrationsByDepartment": "Elektè enskri pa depatman",
    "reporting.registrationsElsewhere": "enskripsyon pa kont ki asiyen lòt kote",
    "reporting.registrationsLower": "enskripsyon",
    "reporting.remaining": "Rete",
    "reporting.residenceGeography": "Jewografi rezidans",
    "reporting.retransmissionsLower": "retransmisyon",
    "reporting.scrollZoomHistoryHelp": "Defile oswa fè zoom sou tout istorik la. Klike sou yon ba pou egzamine jou sa a.",
    "reporting.selectDay": "Chwazi yon jou",
    "reporting.selected": "Chwazi",
    "reporting.selectedCenter": "Sant chwazi",
    "reporting.sexDistribution": "Distribisyon sèks",
    "reporting.sourceMix": "Melanj sous",
    "reporting.standardActivityDepartments": "Elektè enskri pa depatman.",
    "reporting.standardLower": "estanda",
    "reporting.standardRegistration": "Rapò sou enskripsyon estanda",
    "reporting.standardRegistrations": "Enskripsyon estanda",
    "reporting.statusProfile": "Pwofil estati",
    "reporting.submittedApplications": "Demann soumèt",
    "reporting.temporalFingerprint": "Anprent tan",
    "reporting.totalCapacity": "kapasite total",
    "reporting.turnoutTrajectory": "Trajektwa patisipasyon",
    "reporting.typeTwoChars": "Tape omwen de karaktè",
    "reporting.under18": "Mwens pase 18 an",
    "reporting.uniqueApplicantNinus": "NINU inik aplikan",
    "reporting.uniqueApplicants": "Aplikan inik",
    "reporting.uniqueNinus": "NINU inik",
    "reporting.unknownCenter": "Sant enkoni",
    "reporting.unknownError": "Erè rapò enkoni",
    "reporting.unknownOperator": "Operatè enkoni",
    "reporting.unknownResidenceSection": "Seksyon rezidans enkoni",
    "reporting.unknownSection": "Seksyon enkoni",
    "reporting.unnamedCenter": "Sant san non",
    "reporting.utilization": "Itilizasyon",
    "reporting.utilized": "itilize",
    "reporting.viewCenterReport": "Gade rapò sant vòt",
    "reporting.views": "Vizyalizasyon rapò",
    "reporting.voterDemographics": "Demografi elektè enskri",
    "reporting.voterDemographicsSubtitle": "Distribisyon sèks ak laj elektè enskri yo.",
    "reporting.votersLastStation": "Elektè nan dènye biwo",
    "reporting.votersLower": "elektè",
    "reporting.votingCenterIntelligence": "Analiz sant vòt",
    "reporting.votingCenterReports": "Rapò sant vòt",
    "reporting.votingCenters": "Sant vòt",
    "reporting.workforce": "Mendèv",
    "user.account": "Kont",
    "user.accountRequest": "Demann kont itilizatè",
    "user.accounts": "Kont",
    "user.additionalGranularPermission": "pèmisyon granilè anplis",
    "user.additionalGranularPermissions": "pèmisyon granilè anplis",
    "user.apiKey": "Kle API",
    "user.apiKeyCopied": "Kle API kopye.",
    "user.apiKeyCurrentCannotBeViewed": "Kle API aktyèl la pa ka afiche. Lè ou jenere yon nouvo kle, ansyen kle a vin pa valab touswit.",
    "user.apiUser": "Itilizatè API",
    "user.apiUserNotFound": "Itilizatè API a pa jwenn.",
    "user.applicantSubtitle": "Idantite ak enfòmasyon kont mande",
    "user.approvalRequest": "Demann apwobasyon",
    "user.approvalRequestGid": "GID demann apwobasyon",
    "user.approvalRequestSubtitle": "Demann sous ki kreye kont sa a",
    "user.approve": "Apwouve",
    "user.assignedRoles": "Wòl ki atribye",
    "user.rolesAndPermissions": "Wòl ak pèmisyon",
    "user.selectFunctionalAccessGranular": "Chwazi yon wòl pou bay tout pèmisyon li yo, oswa louvri li pou chwazi pèmisyon yo youn pa youn.",
    "user.savePermissions": "Anrejistre pèmisyon yo",
    "user.permissionAssignmentsSaved": "Pèmisyon yo anrejistre.",
    "user.audit": "Odit",
    "user.backToApiUsers": "Retounen nan itilizatè API yo",
    "user.backToUsers": "Retounen nan itilizatè yo",
    "user.copyApiKeyNow": "Kopye kle sa a kounye a. Li p ap parèt ankò.",
    "user.createdAccount": "Kont kreye",
    "user.createdAccountSubtitle": "Kont kreye apre apwobasyon",
    "user.createdAt": "Kreye nan",
    "user.currentAccountStatus": "Estati aktyèl kont lan",
    "user.decision": "Desizyon",
    "user.decisionReason": "Rezon desizyon",
    "user.decisionSubtitle": "Metadata rezilta revizyon",
    "user.decisionTime": "Lè desizyon",
    "user.fieldOperatorAccount": "Kont operatè teren",
    "user.generateApiKey": "Jenere yon nouvo kle API",
    "user.identitySubtitle": "Idantite operatè ak non koneksyon",
    "user.invalidQalaaUserId": "ID itilizatè Qalaa pa valab.",
    "user.lifecycleTimestamps": "Dat ak lè sik lavi",
    "user.newApiKey": "Nouvo kle API",
    "user.newApiUser": "Nouvo itilizatè API",
    "user.openPersonRecord": "Louvri dosye moun nan",
    "user.openRequest": "Louvri demann",
    "user.profileCouldNotBeLoaded": "Pwofil itilizatè a pa t kapab chaje.",
    "user.qalaaId": "ID Qalaa",
    "user.qalaaUser": "Itilizatè Qalaa",
    "user.reject": "Rejte",
    "user.requestGid": "GID demann",
    "user.requestStatus": "Estati demann",
    "user.roleAssignmentsCouldNotBeSaved": "Atribisyon wòl yo pa t kapab anrejistre.",
    "user.roleAssignmentsSaved": "Atribisyon wòl yo anrejistre.",
    "user.saveRoles": "Anrejistre wòl yo",
    "user.selectFunctionalAccess": "Chwazi aksè fonksyonèl itilizatè sa a bezwen.",
    "user.synchronizationFailed": "Senkronizasyon echwe.",
    "user.synchronize": "Senkronize",
    "user.synchronizing": "Senkronizasyon...",
    "user.tagsSubtitle": "Endikatè sistèm ki tache ak demann sa a",
    "user.unableGenerateApiKey": "Pa kapab jenere kle API a.",
    "user.unableLoadApiUser": "Pa kapab chaje itilizatè API a.",
    "user.unableSaveApiUser": "Pa kapab anrejistre itilizatè API a.",
    "user.updatedAt": "Mizajou nan",
    "user.userAccount": "Kont itilizatè",
    "user.userNotFound": "Itilizatè pa jwenn.",
    "user.username": "Non itilizatè",
    "user.viewAccount": "Gade kont",
    "user.viewApiUser": "Gade itilizatè API",
    "user.viewApprovalRequest": "Gade demann apwobasyon",
    "user.viewProfile": "Gade pwofil",
    "user.viewVotingCenter": "Gade sant vòt",
    "user.votingCenterRequestSubtitle": "Afektasyon operatè mande pandan enskripsyon",
    "user.votingCenterSubtitle": "Afektasyon operatè teren",
    "user.willBePreserved": "ap konsève.",
    "voter.applicant": "Aplikan",
    "voter.applicantNinu": "NINU aplikan",
    "voter.applicantSnapshot": "Rezime aplikan",
    "voter.application": "Demann enskripsyon elektè",
    "voter.application.subtitle": "Dosye revizyon demann nan",
    "voter.applicationMetadataSubtitle": "Resi, sous, delè ak metadata revizyon",
    "voter.applicationPhoto": "Foto demann",
    "voter.attempts": "Tantativ",
    "voter.lastAttempt": "Dènye tantativ",
    "voter.primaryApplication": "Demann prensipal",
    "voter.rejectedAt": "Rejte",
    "voter.archivedAt": "Achive",
    "voter.applicationPhotoAlt": "Pòtrè demann elektoral",
    "voter.applicationType": "Kalite demann",
    "voter.applicationsLinked": "Demann enskripsyon ki lye ak moun sa a",
    "voter.assignedVotingLocation": "Kote vòt ki asiyen",
    "voter.birthDate": "Dat nesans",
    "voter.checked": "Verifye",
    "voter.correction": "Koreksyon",
    "voter.correctionApplication": "Demann koreksyon",
    "voter.duplicate": "Doub",
    "voter.gpsCoordinates": "Kowòdone GPS",
    "voter.gpsSubtitle": "Kote demann nan te soumèt",
    "voter.gpsUnavailable": "Kowòdone GPS pa disponib",
    "voter.identitySnapshotSubtitle": "Rezime idantite ki te soumèt ak demann sa a",
    "voter.manualAdjudication": "Revizyon manyèl",
    "voter.manualEntry": "Antre manyèl",
    "voter.mrzNfc": "MRZ NFC",
    "voter.mrzSlashNfc": "MRZ / NFC",
    "voter.ninu": "NINU",
    "voter.noPhoto": "Pa gen foto",
    "voter.noPortrait": "Pa gen pòtrè",
    "voter.oniPhoto": "Foto ONI",
    "voter.oniPhotoAlt": "Pòtrè ONI",
    "voter.oniSearch": "Rechèch ONI",
    "voter.operator": "Operatè",
    "voter.operatorUserGid": "GID itilizatè operatè",
    "voter.personResolved": "Moun idantifye",
    "voter.selfService": "Oto-enskripsyon",
    "voter.personName": "Non moun",
    "voter.receipt": "Resi",
    "voter.receiptNumber": "Nimewo resi",
    "voter.correctReceiptNumber": "Korije nimewo resi",
    "voter.newReceiptNumber": "Nouvo nimewo resi",
    "voter.saveCorrection": "Anrejistre koreksyon an",
    "voter.correctionFailed": "Pa kapab anrejistre koreksyon an",
    "voter.correctionJournal": "Jounal koreksyon",
    "voter.correctionJournalSubtitle": "Koreksyon ki fèt sou demann enskripsyon elektè sa a",
    "voter.noCorrections": "Pa gen okenn koreksyon ki fèt.",
    "voter.journal.receiptNumberCorrected": "Nimewo resi korije",
    "voter.oldValue": "Ansyen valè",
    "voter.newValue": "Nouvo valè",
    "voter.correctedBy": "Korije pa",
    "voter.record": "Dosye elektè",
    "voter.record.subtitle": "Afektasyon elektè ki enskri",
    "voter.registeredCitizenIdentity": "Idantite sitwayen ki enskri",
    "voter.requestedVotingLocation": "Kote vòt mande",
    "voter.retransmission": "Retransmisyon",
    "voter.reviewedAt": "Revize nan",
    "voter.reviewer": "Revizè",
    "voter.reviewerUserGid": "GID itilizatè revizè",
    "voter.standard": "Estanda",
    "voter.statusCode": "Kòd estati",
    "voter.submittedAt": "Soumèt nan",
    "voter.usersInvolved": "Itilizatè ki patisipe nan soumisyon ak revizyon",
    "voter.viewApplication": "Gade demann",
    "voter.viewVoterRecord": "Gade dosye elektè",
    "voter.voter": "Elektè",
    "voter.votingCenter": "Sant vòt",
    "voter.votingCenterGid": "GID sant vòt",
    "voter.votingCenterId": "ID sant vòt",
    "en-US": "Angle",
    "fr-FR": "Franse",
    "ht-HT": "Ayisyen",
    "reporting.applicants": "Aplikan",
    "reporting.applicantsLower": "aplikan",
    "reporting.applicantsByDay": "Aplikan pa jou",
    "reporting.applicantsByCenter": "Aplikan pa sant vòt",
    "reporting.applicantCadence": "Kadans aplikan yo",
    "reporting.noApplicantActivity": "Pa gen aktivite aplikan.",
    "reporting.noApplicantsDay": "Pa gen aplikan pou jou sa a.",
    "reporting.noApplicantHistory": "Pa gen istwa aplikan.",
    "reporting.applicantCapacity": "Kapasite ak aplikan",
    "reporting.applicantsElsewhere": "aplikan ki afekte lòt kote",
    "reporting.applicantCatchment": "Zòn kote aplikan yo soti",
    "reporting.dailyApplicantActivity": "Aktivite aplikan pa jou",
    "reporting.noApplicantsSelection": "Pa gen aplikan pou seleksyon sa a.",
    "reporting.pendingApplications": "Demann k ap trete",
    "Loading metadata": "Ap chaje metadone yo",
    "role.systemAdministrator": "Administratè sistèm",
    "role.systemAdministrator.description": "Aksè konplè a tout fonksyon ki sekirize yo.",
    "role.userAdministration": "Administrasyon itilizatè",
    "role.userAdministration.description": "Jere itilizatè yo ak otorizasyon yo.",
    "role.statisticalReports": "Rapò estatistik",
    "role.statisticalReports.description": "Gade rapò estatistik, demografik ak jewografik yo.",
    "role.operationalReports": "Rapò operasyonèl",
    "role.operationalReports.description": "Gade rapò operasyonèl operatè yo ak sant vòt yo.",
    "role.operatorManagement": "Jesyon operatè",
    "role.operatorManagement.description": "Revize demann operatè teren yo epi jere kont operatè yo.",
    "role.voterRegistrationManagement": "Jesyon enskripsyon elektè",
    "role.voterRegistrationManagement.description": "Jere dosye elektè yo, demann yo ak enfòmasyon idantite ki asosye yo.",
    "role.electoralGeographyManagement": "Jesyon jewografi elektoral",
    "role.electoralGeographyManagement.description": "Jere jewografi elektoral la ak sant vòt yo.",
    "role.diagnosticsManagement": "Jesyon dyagnostik",
    "role.diagnosticsManagement.description": "Gade epi jere rapò dyagnostik aparèy teren yo.",
    "reporting.exportExcel": "Ekspòte nan Excel",
    "reporting.exportingExcel": "Ap ekspòte...",
    "reporting.exportFailed": "Pa kapab ekspòte estatistik sant vòt yo.",
    "voterRoll.preliminaryRolls": "Lis elektoral preliminè",
    "voterRoll.preliminaryRolls.description": "Kreye, konsilte epi amande lis elektoral preliminè yo.",
    "voterRoll.finalRolls": "Lis elektoral final",
    "voterRoll.finalRolls.description": "Konsilte epi enprime lis elektoral final yo.",
    "voterRoll.preliminary": "Lis elektoral preliminè",
    "voterRoll.final": "Lis elektoral final",
    "voterRoll.roll": "Lis elektoral",
    "voterRoll.event": "Evènman elektoral",
    "voterRoll.eventDate": "Dat evènman an",
    "voterRoll.cutoff": "Dat limit pou demann yo",
    "voterRoll.createdAt": "Dat kreyasyon",
    "voterRoll.closedAt": "Dat fèmti",
    "voterRoll.entries": "Elektè",
    "voterRoll.amendments": "Amandman",
    "voterRoll.sourceRoll": "Lis sous",
    "voterRoll.viewRoll": "Gade lis la",
    "voterRoll.notFound": "Lis elektoral la pa jwenn.",
    "voterRoll.typeMismatch": "Kalite lis elektoral la pa koresponn ak paj sa a.",
    "voterRoll.preview": "Apèsi lis elektoral la",
    "voterRoll.livePreview": "Apèsi lis elektoral aktyèl la",
    "voterRoll.loadingPreview": "Ap chaje apèsi lis elektoral la...",
    "voterRoll.registeredVoters": "elektè enskri",
    "voterRoll.pollingStations": "biwo vòt",
    "voterRoll.pollingStation": "Biwo vòt",
    "voterRoll.votersLower": "elektè",
    "voterRoll.printBooklet": "Enprime liv la",
    "voterRoll.preparingBooklet": "Preparasyon liv la…",
    "voterRoll.openingPrintDialog": "Ouvèti fenèt enpresyon an…",
    "voterRoll.previewLiveNotice": "Apèsi sa a montre rejis elektoral la jan li ye kounye a. Li ka toujou chanje jiskaske lis elektoral preliminè a kreye.",
    "voterRoll.agencyName": "Konsèy Elektoral Pwovizwa",
    "voterRoll.bookletTitle": "Lis elektoral",
    "voterRoll.livePreviewType": "APÈSI - DONE AKTYÈL",
    "voterRoll.number": "N°",
    "voterRoll.photo": "Foto",
    "voterRoll.familyName": "Siyati",
    "voterRoll.firstName": "Non",
    "voterRoll.dateOfBirth": "Dat nesans",
    "voterRoll.sex": "Sèks",
    "voterRoll.status.queued": "Ann atant",
    "voterRoll.status.generating": "Ap jenere",
    "voterRoll.status.open": "Ouvè",
    "voterRoll.status.closed": "Fèmen",
    "voterRoll.status.failed": "Echèk",
    "voterRoll.status.ready": "Pare",
    "menu.reporting.tablets": "Rapò sou tablèt yo",
    "filter.tabletFilters": "Filtè tablèt yo",
    "filter.refineTablets": "Rafine lis tablèt yo",
    "reporting.tablet": "Tablèt",
    "reporting.tabletVrApplication": "Aplikasyon VR",
    "reporting.tabletBattery": "Batri",
    "reporting.tabletLastContact": "Dènye kontak",
    "reporting.tabletContactMdm": "MDM",
    "reporting.tabletContactBackend": "Sèvè VR",
    "reporting.tabletRequiredVersion": "Vèsyon obligatwa",
    "reporting.tabletCurrent": "Ajou",
    "reporting.tabletOperational": "Fonksyone",
    "reporting.tabletCondition": "Eta",
    "reporting.tabletAssignment": "Atribisyon",
    "reporting.tabletIncludeUnassigned": "Mete tablèt ki poko atribye bay yon operatè",
    "reporting.tabletNoOperator": "Poko atribye",
    "reporting.tabletStale": "Pa gen kontak ak MDM oswa sèvè VR depi plis pase 24 èdtan",
    "reporting.tabletOutdated": "Aplikasyon VR la pa ajou",
    "reporting.tabletAppMissing": "Aplikasyon VR la manke",
    "reporting.tabletStaleShort": "Pa gen kontak resan",
    "reporting.tabletOutdatedShort": "Aplikasyon pa ajou",
    "reporting.tabletAppMissingShort": "Aplikasyon manke",
  "common.ok": "OK",
  "geo.mergeCenters": "Fizyone sant vòt yo",
  "geo.closeAndRedirect": "Dezaktive epi redirije",
  "geo.sourceCenter": "Sant pou dezaktive a",
  "geo.destinationCenter": "Sant ki rete / destinasyon",
  "geo.searchCenter": "Chèche pa non oswa kòd",
  "geo.swapCenters": "Chanje sant ki rete a",
  "geo.votersToMove": "elektè k ap tann transfè chak èdtan",
  "geo.applicationsToMove": "demann ki toujou refere sant sa a",
  "geo.redirectConfirmation": "Sant sous la ap dezaktive epi sistèm nan ap anrejistre sant destinasyon an. Yon travay chak èdtan ap transfere elektè ki deja la. Demann ki toujou refere sant sa a ap pran nouvo sant la anvan apwobasyon kreye yon elektè. Lis ki deja pibliye yo pap chanje.",
  "geo.redirectNextSteps": "Okenn dosye pa transfere pandan operasyon sa a.",
  "geo.confirmMerge": "Konfime fizyon an",
  "geo.confirmClosure": "Konfime fèmti ak redireksyon an",
  "geo.redirectedTo": "Redirije nan",
  "geo.redirectCompleted": "Redireksyon fini",
  "geo.unableToDisableVotingCenter": "Pa kapab dezaktive sant vòt la",
  "geo.votingCenterCannotBeDisabled": "Sant vòt sa a pa kapab dezaktive paske gen elektè ak demand enskripsyon elektoral ki asosye avè l.",
  "geo.votingCenterCannotDisableVotersAndApplications": "Sant vòt sa a pa ka dezaktive paske gen elektè ak demann enskripsyon elektoral ki asosye avè l.",
  "geo.votingCenterCannotDisableVoters": "Sant vòt sa a pa ka dezaktive paske gen elektè ki asosye avè l.",
  "geo.votingCenterCannotDisableApplications": "Sant vòt sa a pa ka dezaktive paske gen demann enskripsyon elektoral ki asosye avè l.",
  "geo.votingCenterCannotDisableNotEmpty": "Sant vòt sa a pa ka dezaktive paske li pa vid.",
  "common.enabled": "Aktive",

  "Request": "Demann",
  "Approve": "Apwouve",
  "Reject": "Rejte",
  "Enrollment": "Rejte enskripsyon an",
  "common.requestLifecycle": "Sik lavi demann lan",
  "ERROR": "Erè",
  "common.createdUser": "Itilizatè kreye",
  "common.signatureUserCreatedAfterApproval": "Itilizatè siyati kreye apre apwobasyon",
  "common.decision": "Desizyon",
  "common.reviewByBackoffice": "Revizyon pa Backoffice",
  "common.decisionReason": "Rezon desizyon an",
  "common.signature": "Siyati",
  "common.requestedPublicSigningIdentity": "Idantite piblik pou siyati yo mande a",
  "common.publicKey": "Kle piblik",
  "common.additionalInformation": "Enfòmasyon adisyonèl",
  "common.enrollmentSpecificAttributes": "Atribi espesifik pou enskripsyon an",
  "common.requestedSignatureAccountIdentity": "Idantite kont siyati yo mande a",
  
  // API developer documentation
  "app.menu.developer.label": "Devlopè",
  "app.menu.developer.apiDocumentation": "Dokimantasyon API",
  "developer.apiDocs.title": "Dokimantasyon API",
  "developer.apiDocs.developerDocumentation": "Dokimantasyon pou devlopè",
  "developer.apiDocs.guide": "Gid",
  "developer.apiDocs.reference": "Referans",
  "developer.apiDocs.searchEndpoints": "Chèche pwen API",
  "developer.apiDocs.noEndpointsMatch": "Pa gen okenn pwen API ki koresponn ak rechèch la.",
  "developer.apiDocs.accessDenied": "Aksè nan dokimantasyon API refize",
  "developer.apiDocs.pageRequires": "Paj sa a egzije",
  "developer.apiDocs.documentationGuide": "Gid dokimantasyon",
  "developer.apiDocs.description": "Deskripsyon",
  "developer.apiDocs.usage": "Itilizasyon",
  "developer.apiDocs.request": "Demann",
  "developer.apiDocs.pathParameters": "Paramèt chemen",
  "developer.apiDocs.queryParameters": "Paramèt query",
  "developer.apiDocs.unresolvedParameters": "Paramèt ki pa rezoud",
  "developer.apiDocs.body": "Kò",
  "developer.apiDocs.mode": "Mòd",
  "developer.apiDocs.noRequestBody": "Pa gen kò demann.",
  "developer.apiDocs.response": "Repons",
  "developer.apiDocs.notes": "Nòt",
  "developer.apiDocs.tryIt": "Eseye li",
  "developer.apiDocs.name": "Non",
  "developer.apiDocs.type": "Tip",
  "developer.apiDocs.values": "Valè",
  "developer.apiDocs.default": "Valè pa defo",
  "developer.apiDocs.item": "atik",
  "developer.apiDocs.nullable": "ka vid",
  "developer.apiDocs.unique": "inik",
  "developer.apiDocs.predicate": "Predika",
  "developer.apiDocs.permission": "Otorizasyon",
  "developer.apiDocs.requiresPermission": "Egzije {permission}",
  "developer.apiDocs.predicateProtected": "Egzekisyon an pwoteje pa predika {predicate}; sèlman genyen yon otorizasyon pa sifi pou pre-otorize li.",
  "developer.apiDocs.unspecifiedPolicy": "Pwen API sa a pa gen okenn politik egzekisyon eksplisit.",
  "developer.apiDocs.headers": "Antèt",
  "developer.apiDocs.empty": "(vid)",
  "developer.apiDocs.execute": "Egzekite",
  "developer.apiDocs.executing": "Ap egzekite…",
  "developer.apiDocs.copyCurl": "Kopye cURL",
  "developer.apiDocs.sessionNote": "Egzekisyon nan navigatè a itilize sesyon aktyèl la. cURL ki kopye a pa gen kalifikasyon sesyon navigatè a.",
  "developer.apiDocs.emptyServiceUri": "getServiceUri() retounen yon URI sèvis vid",
  "developer.apiDocs.mustBeJsonObject": "{name} dwe yon objè JSON",
  "developer.apiDocs.unboundParameters": "Pwen API sa a gen paramèt ki pa gen okenn lyezon HTTP nan kontra REST ki jenere a.",
  "developer.apiDocs.multipleBodies": "Pwen API sa a deklare plizyè kò demann epi li pa ka reprezante kòm yon sèl demann HTTP brit.",
  "developer.apiDocs.methodBodyUnsupported": "Yon demann {method} ki gen yon kò pa ka egzekite ak API Fetch navigatè a.",
  "developer.apiDocs.pathParameterRequired": "Paramèt chemen {name} obligatwa",
  "developer.apiDocs.unresolvedPathVariable": "Gen yon varyab chemen ki poko rezoud nan {path}",

  "voter_application.deduplicated_status": "Dediplikasyon fèt",
  "voter_application.face_verification_mismatch_status": "Verifikasyon vizaj pa koresponn"
};
